




















































































































// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';
import { editFactory } from '@/main/pages/editFactory';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { editActions, editMutations } from '@/modules/sklad/pneuSklad/store/types';
import { EventBus } from '@/main/eventBus';
import { Partner } from '@/modules/kartoteka/partner';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Texty } from '@/modules/ciselnik/firemni/texty';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Zakazka } from '@/modules/servis/zakazka';
import { SkladoveMistoPneu } from '@/modules/ciselnik/pneu/skladoveMistoPneu';
import { ZAKAZKA_DRUH, NAME as ZAKAZKA } from '@/modules/servis/zakazka/constants';
import { openEdit, openSelectList } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { Route } from 'vue-router';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import DmsDphCalculator from '#components/dms/dphCalculator/DmsDphCalculator.vue';

import PneuTable from './components/PneuTable.vue';
import { store } from './store/edit';
import { DEFAULT_POCET_PNEU, NAME, POLOZKA_PREFIX } from './constants';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		vozidloSelect: Vozidlo.components.Select,
		zakazkaSelect: Zakazka.components.Select,
		pracovnikSelect: Pracovnik.components.Select,
		DmsDphCalculator,
		PartnerSelect: Partner.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		PneuTable,
		skladMistoPneuSelect: SkladoveMistoPneu.components.Select,
		textySelect: Texty.components.Select,
		DmsPdfDialog,
	},
	data() {
		return {
			pneuLoading: false,
			upozorneniVisible: false,
			tiskDialog: {
				show: false,
				url: null as string | null,
				filter: null as object | null,
				fetchPdfProvider: null as (() => Promise<any>) | null,
			},
			ZAKAZKA_DRUH,
			visible: false,
			dialog: {
				create: false,
			},
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				skladMisto: `${this.storeUri}/${editMutations.SKLAD_MISTO_SELECT_MAPPER}`,
				zakazka: `${this.storeUri}/${editMutations.ZAKAZKA_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${editMutations.VOZIDLO_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${editMutations.ZAKAZNIK_SELECT_MAPPER}`,
				VstupZakaznik: `${this.storeUri}/${editMutations.VSTUP_ZAKAZNIK_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${editMutations.PRACOVNIK_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.NAKLAD_STREDISKO_SELECT_MAPPER}`,
				texty: `${this.storeUri}/${editMutations.SKLAD_PNEU_TEXTY_SELECT_MAPPER}`,
			};
		},
		actionsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${editActions.PRACOVNIK_SELECT_ZMENA}`,
				skladMisto: `${this.storeUri}/${editActions.SKLAD_MISTO_SELECT_ZMENA}`,
				vozidlo: `${this.storeUri}/${editActions.VOZIDLO_SELECT_ZMENA}`,
				zakazka: `${this.storeUri}/${editActions.ZAKAZKA_SELECT_ZMENA}`,
			};
		},
		createLabel(): string {
			return this.dialog.create ? this.LocalizePopisostatni('cmdNewPZ') : this.LocalizePopisostatni('VlastniZakazky');
		},
		dialogText(): string {
			return this.LocalizePopisostatni('ZobrazZakazkyVozAZak');
		},
		textyFilter(): object {
			return {
				SkladpneuPrp: true,
			};
		},
		skladPneuFilter(): object {
			return { SkladpneuOzn: this.SkladpneuOzn, VolneSkladMisto: true };
		},
		WheelLoaded(): boolean {
			return this.PneuskladPolozky.length === this.polozky.data.length;
		},
		predavaciProtokolTiskFilter(): object {
			return {
				PneuSkladId: this.ZaznamId,
				IsKopia: !!this.TiskDat,
				ReportType: 'pdf',
			};
		},
		pruvodkaTiskFilter(): object {
			return {
				PneuSkladId: this.ZaznamId,
				ReportType: 'pdf',
			};
		},
		vozidloFilter(): object {
			return {
				ZakaznikId: this.ZakaznikId,
			};
		},
	},
	watch: {
		SkladpneuOzn() {
			if (!this.loading) {
				this.zmenaSkladPneu();
			}
		},
		WheelLoaded(newVal) {
			if (newVal) {
				this.pneuLoading = false;
			}
		},
		DphSzbOzn(value) {
			const dphSazbaItem = this.dropdownList.DphSzbOzn.find((dphSazba: { Value: number; Text: string }) => dphSazba.Value === value);
			if (!dphSazbaItem) {
				this.DphSazba = null;
			} else {
				const match = (dphSazbaItem as { Text: string }).Text.match(/(\d+)(%)/)!;
				this.DphSazba = match.length > 1 ? parseInt(match[1], 10) : null;
			}
		},
	},
	methods: {
		async loadedData() {
			if (this.PneuskladPolozky.length) {
				await this.loadPolozkyData();
			} else {
				await this.pneuDefault();
				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < DEFAULT_POCET_PNEU; i++, this.increaseWheel());
			}
		},
		createModalVisible(type: string) {
			this.zakazkaDruh = this.loggedUser.UzivatelData.ZakazkaDruh;
			this.dialog.create = type === 'create';
			this.visible = true;
		},
		async routeCreateZakazka() {
			const extraFilter = {} as any;
			extraFilter.ZakaznikId = this.ZakaznikChecked ? this.ZakaznikId : null;
			extraFilter.VozidloId = this.VozidloChecked ? this.VozidloId : null;
			extraFilter.VozidloIdText = this.VozidloChecked ? this.VozidloIdText : null;
			extraFilter.ZakaznikIdText = this.ZakaznikChecked ? this.ZakaznikIdText : null;
			if (this.dialog.create) {
				openEdit(ZAKAZKA, PageMode.CREATE, {
					props: true,
					filter: {
						ZakazkaDruh: this.zakazkaDruh,
						OtevrenePrp: true,
						...extraFilter,
					},
				});
			} else {
				await openSelectList(ZAKAZKA, {
					filter: { ...extraFilter },
					showFilter: false,
				});
			}
		},
		async closeClick() {
			if (this.reEditMode) {
				this.upozorneniVisible = true;
			} else {
				await this.$router.back();
			}
		},
		reEdit() {
			this.$nextTick(() => {
				this.reEditMode = true;
				EventBus.$emit('DisableAll', false);
			});
		},
		async shouldDestroyPage(to: Route) {
			const shouldDestroy = this.shouldRemoveFromPageManager(to);
			if (shouldDestroy && !_.isNil(this.entityId) && (_.isNull(this.DokladPfx) || _.isNull(this.DokladNr))) {
				this.showErrorNotification(this.LocalizeChyboveHlasky('edtPneuskladNoProtokol'));
				return false;
			}
			return !shouldDestroy || this.getConfirmationForUnsavedEditForm();
		},
		async validatePneus(): Promise<boolean> {
			const pneuTable = this.$refs.pneuTable as Vue;
			const promiseArray = [] as Promise<boolean>[];
			for (let i = 0; i < this.polozky.data.length; i++) {
				const polozka = (pneuTable.$refs[`${POLOZKA_PREFIX}${i}`] as Vue[])[0] as (Vue & { validate: () => Promise<boolean> });
				promiseArray.push(polozka.validate());
			}
			const result = await Promise.all(promiseArray);
			return result.reduce((prevVal, curVal) => prevVal && curVal);
		},
		async save(goBack = true) {
			const pneusValid = await this.validatePneus();
			const isValid = await this.validate();

			if (!isValid || !pneusValid) {
				return new Error('Data are not valid');
			}
			const saveResponse = await (this.isCreateMode ? this.create(goBack) : this.update(goBack));
			if (saveResponse instanceof Error) return saveResponse;

			if (this.isCreateMode) {
				const [, respId] = saveResponse.headers.location.split('=');
				if (respId <= 0) {
					return new Error('Didn\'t get entityId on save');
				}
				this.ZaznamId = respId;
				this.entityId = respId;
				this.polozky.data.forEach((pneu) => {
					pneu.PneuskladId = parseInt(respId, 10);
				});
			}

			if (this.isCreateMode) {
				await this.createPneus();
			} else {
				await this.savePneus();
			}
			return saveResponse;
		},
		async checkUlozeni() {
			let result = null;
			if (this.isCreateMode) {
				result = _.isNil(this.entityId) ? await this.changeToEdit() : await this.changeUrlToEdit(this.entityId);
			} else if (this.isModified) result = await this.save(false);
			return !(result instanceof Error);
		},
		async predavaciProtokol() {
			const saved = await this.checkUlozeni();
			if (!saved) return;
			this.emitDisableAll();
			this.tiskDialog.fetchPdfProvider = async () => {
				try {
					const response = await apiProvider.getPneuPredavaciProtokolReport(this.predavaciProtokolTiskFilter);
					await this.entity();
					return response;
				} catch (error) {
					this.logError(error as Error);
					return error;
				}
			};
			this.tiskDialog.show = true;
			this.reEditMode = false;
		},
		async pruvodka() {
			const saved = await this.checkUlozeni();
			if (!saved) return;
			this.tiskDialog.fetchPdfProvider = async () => apiProvider.getPneuPruvodkaReport(this.pruvodkaTiskFilter);
			this.tiskDialog.show = true;
		},
		tiskOkClicked() {
			this.tiskDialog.show = false;
		},
		emitDisableAll() {
			EventBus.$emit('DisableAll', true);
			this.disabledAll = true;
		},
	},
	mounted() {
		if (this.isCreateMode) {
			this.pneuLoading = false;
		}
		if (this.isEditMode && !this.reEditMode) {
			this.emitDisableAll();
		}
	},
});
